import { resolve } from 'styled-jsx/css';
import { colors } from 'components/styles/variables';
import { useTranslation } from 'react-i18next';
import { footerCss } from 'components/Auth/styles';
import Separator from './Separator';
import AuthTypes from './AuthTypes';
import AuthButton from './Button';
import Header from './Header';
import StageWrapper from './StageWrapper';

interface Props {
  onClickGoogle(): void;
  onClickFacebook(): void;
  onClickEmail(): void;
  onClickLogin(): void;
}

const buttonCss = resolve`
  .button {
    margin: .4em 0;
  }
`;

export default function CreateAccount({
  onClickEmail,
  onClickFacebook,
  onClickGoogle,
  onClickLogin,
}: Props): JSX.Element {
  const { t } = useTranslation();

  return (
    <StageWrapper data-testid="create-account-options">
      <Header>
        <h1 data-testid="headline">{t('auth.createAccount.headline')}</h1>
        <p className="description">{t('auth.createAccount.description')}</p>
        <Separator />
      </Header>
      <AuthButton type={AuthTypes.Google} onClick={onClickGoogle} className={buttonCss.className}>
        {t('auth.createAccount.google')}
      </AuthButton>
      <AuthButton
        type={AuthTypes.Facebook}
        onClick={onClickFacebook}
        className={buttonCss.className}
      >
        {t('auth.createAccount.facebook')}
      </AuthButton>
      <AuthButton type={AuthTypes.Email} onClick={onClickEmail} className={buttonCss.className}>
        {t('auth.createAccount.email')}
      </AuthButton>
      {buttonCss.styles}
      {footerCss.styles}
      <button className={`footer ${footerCss.className}`} onClick={onClickLogin}>
        {t('auth.createAccount.haveAccount')}
      </button>
      <style jsx>{`
        .description {
          color: ${colors.G3};
        }
      `}</style>
    </StageWrapper>
  );
}
